<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style >
  * {
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
  .is-error .el-input .el-input__inner,
  .is-error .el-input .el-input__inner:focus
  .is-error .el-input__inner,
  .is-error .el-input__inner:focus,
  .is-error .el-textarea__inner,
  .is-error .el-textarea__inner:focus,
  .el-message-box__input input.invalid,
  .el-message-box__input input.invalid:focus {
    border-color: #F56C6C;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue